import React, { useRef } from 'react';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { VirtualList } from 'reactApp/ui/VirtualList/VirtualList';
import { EDividerSize } from 'reactApp/ui/VirtualList/VirtualList.types';
import { noopVoid } from 'reactApp/utils/helpers';

import { DateHeader } from '../DateHeader/DateHeader';
import { Item } from '../Item/Item';
import type { LogItem } from '../types';
import styles from './List.css';

type ListProps = {
    items: LogItem[];
};
export const List: React.FC<ListProps> = ({ items }) => {
    const rootRef = useRef<HTMLDivElement>(null);
    const ROW_HEIGHT = 110;
    const DIVIDER_HEIGHT = 36;
    const renderItem = (item: LogItem) => {
        if (typeof item === 'string') {
            return <Item id={item} key={item} />;
        }
        if (item.text) {
            return <DateHeader text={item.text} key={item.text} />;
        }
        return null;
    };
    return (
        <div className={styles.wrapper}>
            <VirtualList
                list={items}
                renderItem={renderItem}
                hasMoreToLoad={false}
                viewMode={EViewMode.list}
                rowHeight={ROW_HEIGHT}
                dividerHeight={DIVIDER_HEIGHT}
                dividerSize={EDividerSize.SMALL}
                isLoading={false}
                loadOnScroll={noopVoid}
                customScrollElement={rootRef.current}
            />
        </div>
    );
};
